module.exports = __webpack_public_path__ + "img/phase-3.b8a23e4f.svg";